export const PXLogoslider = (function() {
	'use strict';

	function init() {
		events();
	}

	function events() {

		var $logo_slider = $('.logo-slider');
		var $window = $(window);
		var window_width = $window.width();
		var image_width = 0;

		$window.on('load', function() {

			$logo_slider.find('img').each( function() {
				var this_width = $(this).width();
				image_width += this_width + 40;
			});

			if ( image_width > window_width ) {
				$('.logo-slider').slick({
					slidesToShow: 5,
					autoplay: true,
					infinite: true,
					variableWidth: true,
					autoplaySpeed: 2000,
					responsive: [
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 3
							}
						}
					],
				});
			}
		});
	}

	return {
		init: init
	};
})();
